import axios from "axios";
import { isEmpty } from "../../utils/helpers";

let BaseUrl = "https://stagebusapi.mavenconnect.tech/api"   // tech
if (window.location.origin.includes('mavenconnect.tech')) { BaseUrl = 'https://stagebusapi.mavenconnect.tech/api' }// tech
else if (window.location.origin.includes('mavenconnect.biz')) { BaseUrl = ('https://bbtbusapi.mavenconnect.tech/api') }
export let QRBaseUrl = 'https://gpg.iamgds.com/api'



const HttpCall = async (url, method, params, body) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = BaseUrl + url;
    const token = sessionStorage.getItem('token');
    axios({
      method: method,
      url: completeUrl,
      data: body,
      params: {
        ...params,
        usage: 'dev'
      },
      headers: {
        "Accept": "application/json",
        "Token": token,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

// For Get Api Calls
const HttpGet = async (url, params, logintoken = null) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = BaseUrl + url;
    const token = sessionStorage.getItem('token');
    axios({
      method: "get",
      url: completeUrl,
      params: {
        ...params,
        usage: 'dev'
      },
      headers: {
        "Accept": "application/json",
        // "Token": logintoken === null ? token : logintoken,
        "Token": token,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};



const memoizedGet = () => {
  const memcache = new Map()
  return async (...args) => {
    let isCache = args?.length > 2 ? args[2] : false
    let isdelete = args?.length > 4 ? args[4] : false
    if (isCache) {
      const selector = JSON.stringify(args.slice(0, 4))
      if (memcache.has(selector)) {
        const { data, timestamp, duration } = memcache.get(selector);
        if ((Date.now() - timestamp) > duration || isdelete) {
          memcache.delete(selector);
        } else {
          return data;
        }
      }
      let url = args[0]
      const completeUrl = BaseUrl + url;
      let queryParams = ''
      const postData = args[1]
      if (typeof postData != 'undefined' && !isEmpty(postData)) {
        Object.entries(postData).forEach((entry) => {
          const [key, value] = entry
          queryParams += `${key}=${value}&`
        })
        url = `${url}${queryParams}`
      }
      return new Promise(async function (resolve, reject) {
        const token = sessionStorage.getItem("token");
        axios({
          method: "get",
          url: completeUrl,
          params: {
            ...postData,
            usage: 'dev'

          },
          headers: {
            Accept: "application/json",
            Token: token,
          },
        }).then((response) => {
          let cacheDuration = args.length > 3 ? args[3] : 30 * 60 * 1000
          if (response && response.status === 200) {
            memcache.set(selector, { data: response, timestamp: Date.now(), duration: cacheDuration })
            return resolve(response);
          }
          return resolve(response);
        })
          .catch((err) => {
            return reject(err);
          });
      })
    } else {
      let url = args[0]
      const postData = args[1]
      return HttpGet(url, postData)
    }
  }
}
export const GetRequestCached = memoizedGet();



const memoizedCall = () => {
  const memcache = new Map()
  return async (...args) => {
    let isCache = args?.length > 4 ? args[4] : false
    let isdelete = args?.length > 6 ? args[6] : false
    if (isCache) {
      const selector = JSON.stringify(args.slice(0, 6))
      if (memcache.has(selector)) {
        const { data, timestamp, duration } = memcache.get(selector);
        if ((Date.now() - timestamp) > duration || isdelete) {
          memcache.delete(selector);
        } else {
          return data;
        }
      }
      let url = args[0]
      const completeUrl = BaseUrl + url;
      const postMethod = args[1]
      const postData = args[2]
      const postBody = args[3]
      return new Promise(async function (resolve, reject) {
        const token = sessionStorage.getItem("token");
        axios({
          method: postMethod,
          url: completeUrl,
          data: postBody,
          params: {
            ...postData,
            usage: 'dev'
          },
          headers: {
            Accept: "application/json",
            Token: token,
          },
        }).then((response) => {
          let cacheDuration = args.length > 5 ? args[5] : 30 * 60 * 1000
          if (response && response.status === 200) {
            memcache.set(selector, { data: response, timestamp: Date.now(), duration: cacheDuration })
            return resolve(response);
          }
          return resolve(response);
        })
          .catch((err) => {
            return reject(err);
          });
      })
    } else {
      let url = args[0]
      const postMethod = args[1]
      const postData = args[2]
      const postBody = args[3]
      return HttpCall(url, postMethod, postData, postBody)
    }
  }
}
export const CallRequestCached = memoizedCall();


const memoizedGet3 = () => {
  const memcache = new Map()

  return async (...args) => {
    let isCache = args?.length > 2 ? args[2] : false
    if (isCache) {
      const selector = JSON.stringify(args)
      if (memcache.has(selector)) {
        const { data, timestamp, duration } = memcache.get(selector);
        if ((Date.now() - timestamp) > duration) {
          memcache.delete(selector);
        } else {
          return data;
        }
      }
      let url = args[0]
      const postData = args[1]
      const response = await HttpGet(url, postData)
      const propmisedData = await response.data
      let cacheDuration = args.length > 3 ? args[3] : 30 * 60 * 1000
      memcache.set(selector, { data: propmisedData, timestamp: Date.now(), duration: cacheDuration })
      return propmisedData
    } else {
      let url = args[0]
      const postData = args[1]
      return HttpGet(url, postData)
    }
  }
}


const HttpCallForQR = async (url, method, params, body) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = QRBaseUrl + url;
    const token = localStorage.getItem('token');
    axios({
      method: method,
      url: completeUrl,
      data: body,
      params: {
        ...params,
      },
      headers: {
        "Accept": "application/json",
        "Token": token,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};


const HttpGetForQR = async (url, params, logintoken = null) => {
  return new Promise(async function (resolve, reject) {
    const completeUrl = QRBaseUrl + url;
    const token = localStorage.getItem('token');
    axios({
      method: "get",
      url: completeUrl,
      params: {
        ...params,
        usage: 'dev'
      },
      headers: {
        "Accept": "application/json",
        "Token": logintoken === null ? token : logintoken,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response);
        }
        return resolve(response);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const gstPanValidation = async (url, params) => {
  return new Promise(async function (resolve, reject) {
    const token = localStorage.getItem('token');
    axios({
      method: "get",
      url: url,
      params: {
        ...params
      },
      headers: {
        "Accept": "application/json",
        "Token": token,
      },
    })
      .then((response) => {
        if (response && response.status === 200) {
          return resolve(response.data);
        }
        return reject(response);
      })
      .catch((err) => {
        console.log("Error: ", err);
        return reject(err);
      });
  });
};
const GetRequestCachedV3 = memoizedGet3();
const httpServices = {
  HttpCall,
  HttpGet,
  GetRequestCached,
  GetRequestCachedV3,
  CallRequestCached,
  HttpGetForQR,
  HttpCallForQR,
  gstPanValidation,
};

export default httpServices;